module.exports = __webpack_public_path__ + "static/cubic_gate-0996b96302d7fb9525220185b914610a.jpeg";